// src/components/StrategicObjectives.js
import React from 'react';

const StrategicObjectives = ({ objectives }) => {
  // Agregar punto al final de cada objetivo si no lo tiene
  const objectivesWithDot = objectives.map(obj => {
    return obj.endsWith('.') ? obj : obj + '.';
  });

  return (
    <div className="mb-16 rounded-xl shadow-lg p-8 border" style={{ backgroundColor: '#211F1F', borderColor: '#333' }}>
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-6" style={{ color: 'white' }}>
        Objetivos <span style={{ color: '#E8B00C' }}>Estratégicos</span>
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {objectivesWithDot.map((objective, index) => (
          <div key={index} className="flex items-start gap-3">
            <span className="font-bold text-xl flex-shrink-0" style={{ color: '#E8B00C' }}>✓</span>
            <span className="text-gray-300 text-base">{objective}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrategicObjectives;